/**
 * DEVELOPER DOCUMENTATION (Focal theme) — see theme docs for events:
 * variant:changed, variant:added, cart:updated, cart:refresh; custom elements
 * (drawer, popover, quick-buy-drawer...) expose an "open" property.
 */

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: Globo (Smart Product Filter) collection grid quick view + quiet add-to-cart
 *
 * 1. Moves Globo's .open-quick-view link into the hover Add-to-cart form row.
 * 2. Hijacks quick-view clicks to the theme's lightweight quick-buy drawer.
 * 3. Hijacks Globo's Add-to-cart form (a plain POST to /cart/add that would
 *    navigate to the cart page): adds via AJAX instead, fires the theme's
 *    green "added to cart" notification, team-colored confetti and a
 *    mini-cart refresh — the shopper stays on the page.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  function placeGloboQuickViews() {
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      var quickView = card.querySelector('.open-quick-view');
      var form = card.querySelector('.spf-product__form');

      if (quickView && form && quickView.parentElement !== form) {
        form.appendChild(quickView);
      }
    });
  }

  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      placeGloboQuickViews();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  function getCardProductPath(card) {
    var link = card.querySelector('a.spf-product-card__image-wrapper[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      return new URL(link.getAttribute('href'), window.location.origin).pathname;
    } catch (error) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var quickView = event.target.closest ? event.target.closest('.spf-product-card .open-quick-view, .spf-product__form .open-quick-view') : null;
    if (!quickView) return;

    var card = quickView.closest('.spf-product-card');
    if (!card) return;

    var productPath = getCardProductPath(card);
    if (!productPath || !window.customElements || !window.customElements.get('quick-buy-drawer')) {
      return; // fall back to Globo's own quick view
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var previous = document.getElementById('zubaz-globo-quick-buy');
    if (previous) previous.remove();

    var drawer = document.createElement('quick-buy-drawer');
    drawer.id = 'zubaz-globo-quick-buy';
    drawer.setAttribute('href', productPath);
    drawer.className = 'drawer drawer--large drawer--quick-buy';
    document.body.appendChild(drawer);

    requestAnimationFrame(function () {
      drawer.open = true;
    });
  }, true);

  /* quiet add-to-cart for Globo grid forms */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches) return;
    if (!form.matches('form.spf-product__form') && !form.matches('.spf-product-card form[action*="/cart/add"]')) return;

    event.preventDefault();

    var btn = form.querySelector('button[type="submit"], button.spf-product__form-btn-addtocart');
    var originalText = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (item) {
        var card = form.closest('.spf-product-card');
        var titleLink = card ? card.querySelector('a[href*="/products/"]') : null;
        var title = (item && item.product_title) || (titleLink ? titleLink.textContent : '');

        document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true, cancelable: true, detail: { status: 'success' } }));
        window.zubazConfetti && window.zubazConfetti(window.zubazTeamColorsFromText ? window.zubazTeamColorsFromText(title) : null);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (btn) {
          btn.textContent = 'ADDED ✓';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1600);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit(); // sold out or network issue — fall back to the regular flow
      });
  }, true);
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: shared team data + helpers
 * ------------------------------------------------------------------------------------------------------------ */
window.ZUBAZ_TEAMS = {
  'arizona-cardinals':     { name: 'Arizona Cardinals',     primary: '#97233F', secondary: '#FFB612', slogan: 'Rise Up Red Sea', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Cardinals_Hood.png?v=1721329492' },
  'atlanta-falcons':       { name: 'Atlanta Falcons',       primary: '#A71930', secondary: '#000000', slogan: 'Rise Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Falcons_Hood.png?v=1721331642' },
  'baltimore-ravens':      { name: 'Baltimore Ravens',      primary: '#241773', secondary: '#9E7C0C', slogan: 'Ravens Flock', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_ravens_hood_copy.png?v=1721331481' },
  'buffalo-bills':         { name: 'Buffalo Bills',         primary: '#00338D', secondary: '#C60C30', slogan: 'Bills Mafia', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bills_Hood.png?v=1721330360' },
  'carolina-panthers':     { name: 'Carolina Panthers',     primary: '#0085CA', secondary: '#101820', slogan: 'Keep Pounding', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_panthers_hood_copy.png?v=1721332172' },
  'chicago-bears':         { name: 'Chicago Bears',         primary: '#0B162A', secondary: '#C83803', slogan: 'Da Bears', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bears_Hood.png?v=1721330215' },
  'cincinnati-bengals':    { name: 'Cincinnati Bengals',    primary: '#FB4F14', secondary: '#000000', slogan: 'Who Dey', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bengals_Hood.png?v=1721331338' },
  'cleveland-browns':      { name: 'Cleveland Browns',      primary: '#311D00', secondary: '#FF3C00', slogan: 'Dawg Pound', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Browns_Hood.png?v=1721331065' },
  'dallas-cowboys':        { name: 'Dallas Cowboys',        primary: '#003594', secondary: '#869397', slogan: 'How ’Bout Them Cowboys', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_dallas_copy.png?v=1721332891' },
  'denver-broncos':        { name: 'Denver Broncos',        primary: '#FB4F14', secondary: '#002244', slogan: 'Broncos Country', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Broncos_Hood.png?v=1721330344' },
  'detroit-lions':         { name: 'Detroit Lions',         primary: '#0076B6', secondary: '#B0B7BC', slogan: 'One Pride', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Lions_Hood.png?v=1721331425' },
  'green-bay-packers':     { name: 'Green Bay Packers',     primary: '#203731', secondary: '#FFB612', slogan: 'Go Pack Go', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Packers_Hood.png?v=1721331547' },
  'houston-texans':        { name: 'Houston Texans',        primary: '#03202F', secondary: '#A71930', slogan: 'Bulls On Parade', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_texans_hood_copy.png?v=1721331325' },
  'indianapolis-colts':    { name: 'Indianapolis Colts',    primary: '#002C5F', secondary: '#A2AAAD', slogan: 'For The Shoe', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Colts_Hood.png?v=1721331622' },
  'jacksonville-jaguars':  { name: 'Jacksonville Jaguars',  primary: '#006778', secondary: '#D7A22A', slogan: 'DUUUVAL', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Jaguars_Hood.png?v=1721331580' },
  'kansas-city-chiefs':    { name: 'Kansas City Chiefs',    primary: '#E31837', secondary: '#FFB81C', slogan: 'Chiefs Kingdom', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Chiefs_Hood.png?v=1721330373' },
  'las-vegas-raiders':     { name: 'Las Vegas Raiders',     primary: '#000000', secondary: '#A5ACAF', slogan: 'Raider Nation', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_raiders_hood_copy.png?v=1721331296' },
  'los-angeles-chargers':  { name: 'Los Angeles Chargers',  primary: '#0080C6', secondary: '#FFC20E', slogan: 'Bolt Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Chargers_Hood.png?v=1721331633' },
  'los-angeles-rams':      { name: 'Los Angeles Rams',      primary: '#003594', secondary: '#FFA300', slogan: 'Rams House', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_rams_hood_copy.png?v=1721331278' },
  'miami-dolphins':        { name: 'Miami Dolphins',        primary: '#008E97', secondary: '#FC4C02', slogan: 'Fins Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Dolphins_Hood.png?v=1721331352' },
  'minnesota-vikings':     { name: 'Minnesota Vikings',     primary: '#4F2683', secondary: '#FFC62F', slogan: 'Skol Vikings', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_vikings_hood_copy.png?v=1721331191' },
  'new-england-patriots':  { name: 'New England Patriots',  primary: '#002244', secondary: '#C60C30', slogan: 'Go Pats', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_titans_hood_copy.png?v=1721331531' },
  'new-orleans-saints':    { name: 'New Orleans Saints',    primary: '#101820', secondary: '#D3BC8D', slogan: 'Who Dat', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_saints_hood_copy.png?v=1721331365' },
  'new-york-giants':       { name: 'New York Giants',       primary: '#0B2265', secondary: '#A71930', slogan: 'Big Blue', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Giants_Hood.png?v=1721331503' },
  'new-york-jets':         { name: 'New York Jets',         primary: '#125740', secondary: '#FFFFFF', slogan: 'J-E-T-S', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Jets_Hood.png?v=1721331203' },
  'philadelphia-eagles':   { name: 'Philadelphia Eagles',   primary: '#004C54', secondary: '#A5ACAF', slogan: 'Fly Eagles Fly', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Eagles_Hood.png?v=1721331309' },
  'pittsburgh-steelers':   { name: 'Pittsburgh Steelers',   primary: '#101820', secondary: '#FFB612', slogan: 'Here We Go', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_steelers_hood_copy.png?v=1721331043' },
  'san-francisco-49ers':   { name: 'San Francisco 49ers',   primary: '#AA0000', secondary: '#B3995D', slogan: 'Go Niners', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Forty9ers_Hood.png?v=1721331438' },
  'seattle-seahawks':      { name: 'Seattle Seahawks',      primary: '#002244', secondary: '#69BE28', slogan: 'Go Hawks', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_seahawks_hood_copy.png?v=1721331469' },
  'tampa-bay-buccaneers':  { name: 'Tampa Bay Buccaneers',  primary: '#D50A0A', secondary: '#FF7900', slogan: 'Fire The Cannons', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Buccaneers_Hood.png?v=1721331410' },
  'tennessee-titans':      { name: 'Tennessee Titans',      primary: '#0C2340', secondary: '#4B92DB', slogan: 'Titan Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_titans_hood_copy_5c5d6c6b-e668-4139-b07a-ad8b70e7cdd3.png?v=1721332234' },
  'washington-commanders': { name: 'Washington Commanders', primary: '#5A1414', secondary: '#FFB612', slogan: 'Hail!', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Washington_Hood_copy.png?v=1732038188' }
};

window.zubazTeamTextColor = function (hex) {
  var c = String(hex || '').replace('#', '');
  if (c.length !== 6) return '#ffffff';
  var r = parseInt(c.substr(0, 2), 16);
  var g = parseInt(c.substr(2, 2), 16);
  var b = parseInt(c.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#000000' : '#ffffff';
};

/* Match a product title (or any text) to a team and return confetti colors. */
window.zubazTeamColorsFromText = function (text) {
  if (!text) return null;
  var lower = String(text).toLowerCase();
  var handles = Object.keys(window.ZUBAZ_TEAMS);

  for (var i = 0; i < handles.length; i++) {
    var team = window.ZUBAZ_TEAMS[handles[i]];
    if (lower.indexOf(team.name.toLowerCase()) !== -1) {
      return [team.primary, team.secondary, '#ffffff'];
    }
  }

  return null;
};

window.zubazGetTeam = function () {
  try {
    var h = localStorage.getItem('zubaz-team');
    return (h && window.ZUBAZ_TEAMS[h]) ? h : null;
  } catch (error) {
    return null;
  }
};

window.zubazSetTeam = function (handle) {
  try { localStorage.setItem('zubaz-team', handle); } catch (error) { /* private mode */ }
  document.dispatchEvent(new CustomEvent('zubaz:team', { detail: { handle: handle } }));
};

window.zubazClearTeam = function () {
  try { localStorage.removeItem('zubaz-team'); } catch (error) { /* private mode */ }
  document.dispatchEvent(new CustomEvent('zubaz:team', { detail: { handle: null } }));
};

/* Shared: fetch every product in a collection (products.json caps at 250/page;
   big team collections exceed that, and accessories sort low). Max 4 pages. */
window.zubazFetchCollection = function (handle) {
  var all = [];
  function page(n) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var items = data.products || [];
        all = all.concat(items);
        if (items.length === 250 && n < 4) return page(n + 1);
        return all;
      });
  }
  return page(1);
};

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: add-to-cart celebration (confetti)
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var lastBurst = 0;

  window.zubazConfetti = function (colors) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var now = Date.now();
    if (now - lastBurst < 1500) return;
    lastBurst = now;

    var palette = (colors && colors.length) ? colors : ['#ff37b8', '#f3ff34', '#ffffff', '#000000'];

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:100001;';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var parts = [];

    for (var i = 0; i < 80; i++) {
      parts.push({
        x: canvas.width / 2 + (Math.random() - 0.5) * 120,
        y: canvas.height * 0.35,
        vx: (Math.random() - 0.5) * 16,
        vy: -(5 + Math.random() * 11),
        w: 5 + Math.random() * 6,
        h: 3 + Math.random() * 4,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: palette[i % palette.length]
      });
    }

    var frame = 0;

    function tick() {
      frame++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      parts.forEach(function (p) {
        p.vy += 0.38;
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.99;
        p.rot += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - frame / 80);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      if (frame < 80) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }

    requestAnimationFrame(tick);
  };

  document.addEventListener('variant:added', function (event) {
    var variant = event.detail && event.detail.variant;
    var title = variant ? (variant.product_title || variant.name || variant.title || '') : '';
    window.zubazConfetti(window.zubazTeamColorsFromText(title));
  });

  document.addEventListener('zubaz:confetti', function (event) {
    var detail = event.detail || {};
    var colors = detail.colors || null;

    if (!colors && detail.teamHandle && window.ZUBAZ_TEAMS[detail.teamHandle]) {
      var team = window.ZUBAZ_TEAMS[detail.teamHandle];
      colors = [team.primary, team.secondary, '#ffffff'];
    }

    window.zubazConfetti(colors);
  });
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team picker
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var pills = [];
  var modal = null;

  function nickname(name) {
    var parts = name.split(' ');
    return parts[parts.length - 1];
  }

  function updatePills() {
    var handle = window.zubazGetTeam();

    pills.forEach(function (pill) {
      if (handle) {
        var team = window.ZUBAZ_TEAMS[handle];
        pill.textContent = '🏈 ' + (team.slogan || 'GO ' + nickname(team.name).toUpperCase() + '!');
        pill.style.background = team.primary;
        pill.style.color = window.zubazTeamTextColor(team.primary);
        pill.style.borderColor = team.secondary;
      } else {
        pill.textContent = '🏈 PICK YOUR TEAM';
        pill.style.background = '';
        pill.style.color = '';
        pill.style.borderColor = '';
      }
    });
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'zubaz-team-modal';
    modal.innerHTML =
      '<div class="zubaz-team-modal__overlay" data-action="close"></div>' +
      '<div class="zubaz-team-modal__panel" role="dialog" aria-label="Pick your team">' +
      '<button type="button" class="zubaz-team-modal__close" data-action="close" aria-label="Close">×</button>' +
      '<p class="zubaz-team-modal__title">Who’s your team?</p>' +
      '<p class="zubaz-team-modal__sub">We’ll remember it and point you straight at your gear.</p>' +
      '<a class="zubaz-team-modal__shop" hidden></a>' +
      '<div class="zubaz-team-modal__grid"></div>' +
      '<button type="button" class="zubaz-team-modal__none">No team — just show me everything</button>' +
      '</div>';

    var grid = modal.querySelector('.zubaz-team-modal__grid');

    Object.keys(window.ZUBAZ_TEAMS).forEach(function (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      var btn = document.createElement('button');
      btn.type = 'button';

      if (team.icon) {
        btn.className = 'zubaz-team-modal__team zubaz-team-modal__team--icon';
        btn.title = team.name;
        btn.setAttribute('aria-label', team.name);
        btn.innerHTML = '<img loading="lazy" alt="" src="' + team.icon + '&width=200">';
      } else {
        btn.className = 'zubaz-team-modal__team';
        btn.textContent = team.name;
        btn.style.background = team.primary;
        btn.style.color = window.zubazTeamTextColor(team.primary);
        btn.style.borderBottom = '4px solid ' + team.secondary;
      }

      btn.addEventListener('click', function () {
        window.zubazSetTeam(handle);
        updatePills();
        close();
        window.zubazConfetti && window.zubazConfetti([team.primary, team.secondary, '#ffffff']);
      });
      grid.appendChild(btn);
    });

    modal.querySelector('.zubaz-team-modal__none').addEventListener('click', function () {
      window.zubazClearTeam();
      updatePills();
      close();
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="close"]')) close();
    });

    document.body.appendChild(modal);
  }

  function open() {
    if (!modal) buildModal();

    var shop = modal.querySelector('.zubaz-team-modal__shop');
    var handle = window.zubazGetTeam();

    if (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      shop.hidden = false;
      shop.href = '/collections/' + handle;
      shop.textContent = 'Shop ' + team.name + ' gear →';
    } else {
      shop.hidden = true;
    }

    modal.classList.add('is-open');
  }

  function close() {
    if (modal) modal.classList.remove('is-open');
  }

  function init() {
    if (!window.ZUBAZ_TEAMS) return;

    var hosts = document.querySelectorAll('.header__icon-list');
    if (!hosts.length) {
      var fallback = document.querySelector('.header__wrapper');
      hosts = fallback ? [fallback] : [];
    }

    hosts.forEach(function (host) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'zubaz-team-pill';
      pill.addEventListener('click', open);
      host.appendChild(pill);
      pills.push(pill);
    });

    updatePills();
    document.addEventListener('zubaz:team', updatePills);
    document.addEventListener('zubaz:open-picker', open);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: homepage team personalization
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (window.location.pathname !== '/') return;

  var qvStyle = document.createElement('style');
  qvStyle.textContent =
    '.zubaz-pers-card { position: relative; }' +
    '.zubaz-pers-card__qv { display: block; margin: -16px auto 0; position: relative; background: #ff37b8; color: #ffffff; border: 0; border-radius: 30px; padding: 7px 16px; font-size: 11px; font-weight: 800; letter-spacing: 0.06em; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.25); }' +
    '.zubaz-pers-card__qv:hover { background: #282828; }';
  document.head.appendChild(qvStyle);

  function openQuickBuy(path) {
    if (!path) return;
    if (!window.customElements || !window.customElements.get('quick-buy-drawer')) {
      window.location.href = path;
      return;
    }
    var previous = document.getElementById('zubaz-pers-quick-buy');
    if (previous) previous.remove();
    var drawer = document.createElement('quick-buy-drawer');
    drawer.id = 'zubaz-pers-quick-buy';
    drawer.setAttribute('href', path);
    drawer.className = 'drawer drawer--large drawer--quick-buy';
    document.body.appendChild(drawer);
    requestAnimationFrame(function () { drawer.open = true; });
  }

  function money(value) {
    var n = parseFloat(value);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function findSection(key, title) {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section--featured-collections'));
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-zbz-pers') === key) return sections[i];
      var h = sections[i].querySelector('h2, .heading');
      if (h && h.textContent.trim() === title) return sections[i];
    }
    return null;
  }

  function buildGrid(products) {
    var grid = document.createElement('div');
    grid.className = 'zubaz-pers-grid';

    products.forEach(function (p) {
      var variant = (p.variants || []).filter(function (v) { return v.available !== false; })[0];
      var img = p.images[0].src;
      img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=420';

      var card = document.createElement('a');
      card.className = 'zubaz-pers-card';
      card.href = '/products/' + p.handle;
      card.innerHTML =
        '<img class="zubaz-pers-card__img" loading="lazy" alt="" src="' + img + '">' +
        '<button type="button" class="zubaz-pers-card__qv" data-path="/products/' + p.handle + '">QUICK VIEW</button>' +
        '<div class="zubaz-pers-card__name">' + p.title + '</div>' +
        '<div class="zubaz-pers-card__price">' + money(variant ? variant.price : '') + '</div>';
      grid.appendChild(card);
    });

    grid.addEventListener('click', function (event) {
      var qv = event.target.closest('.zubaz-pers-card__qv');
      if (!qv) return;
      event.preventDefault();
      event.stopPropagation();
      openQuickBuy(qv.getAttribute('data-path'));
    });

    return grid;
  }

  function personalizeSection(key, title, products, headingText, ctaText, ctaHref, note) {
    var sec = findSection(key, title);
    if (!sec || !products.length) return;
    sec.setAttribute('data-zbz-pers', key);

    Array.prototype.forEach.call(sec.querySelectorAll('product-list, .tabs-nav'), function (el) { el.style.display = 'none'; });
    Array.prototype.forEach.call(sec.querySelectorAll('a.button:not(.zubaz-pers-cta)'), function (el) { el.style.display = 'none'; });

    var heading = sec.querySelector('h2, .heading');
    if (heading && headingText) heading.textContent = headingText;

    var host = sec.querySelector('.featured-collections') || sec;

    var oldGrid = sec.querySelector('.zubaz-pers-grid');
    if (oldGrid) oldGrid.remove();
    var oldFoot = sec.querySelector('.zubaz-pers-foot');
    if (oldFoot) oldFoot.remove();

    host.appendChild(buildGrid(products));

    var foot = document.createElement('div');
    foot.className = 'zubaz-pers-foot';
    foot.innerHTML =
      '<a class="button button--primary zubaz-pers-cta" href="' + ctaHref + '">' + ctaText + '</a>' +
      (note ? '<p class="zubaz-pers-note">' + note + '</p>' : '');
    host.appendChild(foot);

    var changeLink = foot.querySelector('[data-zbz-change]');
    if (changeLink) {
      changeLink.addEventListener('click', function (event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('zubaz:open-picker'));
      });
    }
  }

  function personalize() {
    var handle = window.zubazGetTeam && window.zubazGetTeam();
    var team = handle && window.ZUBAZ_TEAMS[handle];

    if (!team) {
      if (document.querySelector('[data-zbz-pers]')) window.location.reload();
      return;
    }

    window.zubazFetchCollection(handle)
      .then(function (products) {
        var valid = (products || []).filter(function (p) {
          if (/gift card/i.test(p.title)) return false;
          if (!p.images || !p.images.length) return false;
          return (p.variants || []).some(function (v) { return v.available !== false; });
        });

        var newest = valid.slice().sort(function (a, b) {
          return new Date(b.published_at) - new Date(a.published_at);
        }).slice(0, 8);

        var newestIds = {};
        newest.forEach(function (p) { newestIds[p.id] = true; });

        var picks = valid.filter(function (p) { return !newestIds[p.id]; }).slice(0, 8);

        personalizeSection(
          'na', 'New Arrivals', newest,
          team.name + ' New Arrivals',
          'SHOP ALL ' + team.name.toUpperCase() + ' NEW ARRIVALS',
          '/collections/' + handle + '?sort_by=created-descending',
          null
        );

        personalizeSection(
          'sbt', 'Shop by team', picks,
          'Your Team: ' + team.name,
          'SHOP ALL ' + team.name.toUpperCase() + ' GEAR',
          '/collections/' + handle,
          'Not your team? <a href="#" data-zbz-change>Change it</a>'
        );
      })
      .catch(function () { /* leave the stock sections */ });
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 200); return; }
    personalize();
    document.addEventListener('zubaz:team', personalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team-color collection pages
 * NOTE: Focal renders the page body in <div id="main"> — there is no <main>.
 * The fit builder's ADD button is excluded — it stays Zubaz pink.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var match = window.location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
  if (!match) return;

  var team = window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[match[1]];
  if (!team) return;

  var style = document.createElement('style');
  style.textContent =
    '#main h1, main h1 { color: ' + team.primary + '; display: inline-block; border-bottom: 5px solid ' + team.secondary + '; padding-bottom: 8px; }' +
    '.zubaz-team-stripe { height: 10px; background: linear-gradient(90deg, ' + team.primary + ' 0 60%, ' + team.secondary + '); }' +
    '#main .button--primary:not(.zubaz-fb__addall), main .button--primary:not(.zubaz-fb__addall) { background: ' + team.primary + ' !important; color: ' + window.zubazTeamTextColor(team.primary) + ' !important; }';
  document.head.appendChild(style);

  function addStripe() {
    var main = document.querySelector('main, #main');
    if (main && !main.querySelector('.zubaz-team-stripe')) {
      var stripe = document.createElement('div');
      stripe.className = 'zubaz-team-stripe';
      main.prepend(stripe);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStripe);
  } else {
    addStripe();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: '90s Mode easter egg
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var KEY = 'zubaz-90s';
  var on = false;

  try { on = localStorage.getItem(KEY) === '1'; } catch (error) { /* private mode */ }

  function apply() {
    document.documentElement.classList.toggle('zubaz-90s', on);
  }

  apply();

  function init() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zubaz-90s-toggle';
    btn.title = "Toggle '90s Mode";
    btn.textContent = "'90s";
    btn.addEventListener('click', function () {
      on = !on;
      apply();
      try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (error) { /* private mode */ }
      if (on && window.zubazConfetti) window.zubazConfetti();
    });
    document.body.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: smarter empty search results
 * Globo renders the /search results asynchronously, so we watch the page:
 * when a query comes back with zero products, show team shortcuts and
 * popular collections instead of a dead end. Hides itself if results appear.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (window.location.pathname.indexOf('/search') !== 0) return;

  var QUICK_LINKS = [
    { label: 'NEW ARRIVALS', href: '/collections/new-arrivals' },
    { label: 'ZUBAZ ORIGINALS', href: '/collections/original-pants' },
    { label: 'ACCESSORIES', href: '/collections/accessories' },
    { label: 'SALE', href: '/collections/sale' }
  ];

  var panel = null;

  function hasQuery() {
    var m = window.location.search.match(/[?&]q=([^&]*)/);
    if (!m) return false;
    try {
      return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().length > 0;
    } catch (error) {
      return m[1].length > 0;
    }
  }

  function resultCount() {
    return document.querySelectorAll(
      '#main .spf-product-card, #main .product-item, #main .product-card'
    ).length;
  }

  function buildPanel() {
    var style = document.createElement('style');
    style.textContent =
      '.zubaz-search-help { max-width: 1000px; margin: 24px auto 60px; padding: 28px 20px 36px; text-align: center; border: 3px solid #ff37b8; border-radius: 12px; background: #fff; }' +
      '.zubaz-search-help[hidden] { display: none; }' +
      '.zubaz-search-help__title { font-weight: 800; text-transform: uppercase; font-size: 18px; margin: 0 0 18px; letter-spacing: .5px; }' +
      '.zubaz-search-help__team-cta { display: inline-block; margin: 0 0 20px; padding: 12px 24px; border-radius: 30px; border: 3px solid transparent; font-weight: 800; text-decoration: none; text-transform: uppercase; }' +
      '.zubaz-search-help__links { display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin: 0 0 24px; }' +
      '.zubaz-search-help__links a { padding: 10px 18px; border-radius: 30px; background: #ff37b8; color: #ffffff; font-weight: 700; font-size: 13px; text-decoration: none; }' +
      '.zubaz-search-help__links a:nth-child(even) { background: #f3ff34; color: #282828; }' +
      '.zubaz-search-help__sub { margin: 0 0 14px; color: #555555; }' +
      '.zubaz-search-help__grid { display: grid; grid-template-columns: repeat(8, 1fr); gap: 10px; max-width: 760px; margin: 0 auto; }' +
      '@media (max-width: 740px) { .zubaz-search-help__grid { grid-template-columns: repeat(4, 1fr); } }' +
      '.zubaz-search-help__grid a { display: block; border-radius: 50%; overflow: hidden; border: 2px solid #eeeeee; aspect-ratio: 1; transition: transform .15s ease, border-color .15s ease; }' +
      '.zubaz-search-help__grid a:hover { transform: scale(1.08); border-color: #ff37b8; }' +
      '.zubaz-search-help__grid img { width: 100%; height: 100%; object-fit: cover; display: block; }';
    document.head.appendChild(style);

    panel = document.createElement('div');
    panel.className = 'zubaz-search-help';

    var teamCta = '';
    var myTeam = window.zubazGetTeam && window.zubazGetTeam();
    if (myTeam && window.ZUBAZ_TEAMS[myTeam]) {
      var t = window.ZUBAZ_TEAMS[myTeam];
      teamCta = '<a class="zubaz-search-help__team-cta" href="/collections/' + myTeam + '" style="background:' + t.primary + ';color:' + window.zubazTeamTextColor(t.primary) + ';border-color:' + t.secondary + '">Shop ' + t.name + ' gear →</a><br>';
    }

    var links = QUICK_LINKS.map(function (l) {
      return '<a href="' + l.href + '">' + l.label + '</a>';
    }).join('');

    var badges = Object.keys(window.ZUBAZ_TEAMS).map(function (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      if (!team.icon) return '';
      return '<a href="/collections/' + handle + '" title="' + team.name + '" aria-label="' + team.name + '"><img loading="lazy" alt="" src="' + team.icon + '&width=200"></a>';
    }).join('');

    panel.innerHTML =
      '<p class="zubaz-search-help__title">No luck with that search — but the zebra’s got you.</p>' +
      teamCta +
      '<div class="zubaz-search-help__links">' + links + '</div>' +
      '<p class="zubaz-search-help__sub">Or jump straight to your team:</p>' +
      '<div class="zubaz-search-help__grid">' + badges + '</div>';

    var host = document.getElementById('main') || document.body;
    host.appendChild(panel);
  }

  function update() {
    if (!hasQuery()) return;

    var empty = resultCount() === 0;
    if (empty && !panel) buildPanel();
    if (panel) panel.hidden = !empty;
  }

  var timer = null;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 400);
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 200); return; }

    setTimeout(update, 1800); // give Globo a chance to render first

    var mainEl = document.getElementById('main');
    if (mainEl) {
      new MutationObserver(schedule).observe(mainEl, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Size-on-button: Focal preselects the first size (X-Small), which risks
   accidental wrong-size orders. Rather than fighting the theme's variant
   engine by deselecting (breaks price/availability state), surface the chosen
   size directly in the ADD TO CART label ("ADD TO CART — MEDIUM") so the size
   is impossible to miss at the moment of commitment. Text-only, no form logic
   touched; skips buttons with inner markup or sold-out state. */
(function () {
  // Focal renders the variant picker OUTSIDE the cart form, and the button
  // label lives in a .loader-button__text span (sibling of the spinner).
  function currentSizeLabel() {
    var checked = document.querySelector('.block-swatch-list input:checked, variant-picker input[type=radio]:checked');
    if (!checked) return '';
    var lab = document.querySelector('label[for="' + checked.id + '"]');
    return (lab ? lab.textContent : checked.value || '').trim();
  }
  function decorate() {
    var size = currentSizeLabel();
    if (!size || size.length > 12) return;
    document.querySelectorAll('.product-form__add-button .loader-button__text').forEach(function (span) {
      var txt = (span.textContent || '').trim();
      if (/sold out|unavailable/i.test(txt)) { delete span.dataset.zbzBase; return; }
      if (!span.dataset.zbzBase) span.dataset.zbzBase = txt.split('—')[0].trim() || 'Add to cart';
      span.textContent = span.dataset.zbzBase + ' — ' + size.toUpperCase();
    });
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(decorate, 200); }
  function init() {
    if (!document.querySelector('.product-form__add-button')) return;
    decorate();
    document.addEventListener('change', schedule, true);
    document.addEventListener('variant:changed', schedule);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
